var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ssQuestionsService } from 'ziphy-web-shared/basic/api';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Textarea } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Title, ToggleButton } from 'ziphy-web-shared/basic/lib/simple';
import RatingStars from 'ziphy-web-shared/basic/lib/simple/ratingStars/RatingStars';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import { $appts } from '@store';
import styles from './ApptSurvey.modal.module.scss';
const ApptSurveyModal = ({ fullAppt, _core }) => {
    const { t } = useTranslation();
    const [fields, setFields] = useState([]);
    const formIsValid = useMemo(() => {
        return true;
        // return _.every(fields, (field) => {
        //   if (field.type === 'stars') {
        //     return field.value > 0
        //   } else if (field.type === 'binary') {
        //     return _.isBoolean(field.value)
        //   } else if (field.type === 'single_choice') {
        //     return field.value.length > 0
        //   } else {
        //     return true
        //   }
        // })
    }, [fields]); //eslint-disable-line react-hooks/exhaustive-deps
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield ssQuestionsService.list({
            filter: {
                contains: ['practice_ids', [fullAppt.appointment.practiceId]],
            },
            order: [['rank', 'asc']],
        });
        let items = ((_a = response.prepared) === null || _a === void 0 ? void 0 : _a.ssQuestions.items) || [];
        let result = [];
        items.forEach((x) => {
            const item = Object.assign({}, x);
            if ((item.topic === 'agent' && !fullAppt[item.topic]) ||
                (item.topic === 'provider' && !fullAppt[item.topic])) {
                return;
            }
            if (item.type === 'stars') {
                item.value = 0;
            }
            else if (item.type === 'multiple_choice') {
                item.value = [];
            }
            else {
                item.value = '';
            }
            result.push(item);
        });
        setFields(result);
    }));
    function setValue(index, value) {
        setFields((prev) => {
            let tmp = [...prev];
            if (tmp[index]) {
                tmp[index] = Object.assign(Object.assign({}, tmp[index]), { value });
            }
            return tmp;
        });
    }
    function handleChange(index, value) {
        let field = fields[index];
        let lastValue = field.value;
        let newValue = value;
        if (field.type === 'multiple_choice' && Array.isArray(lastValue)) {
            if (lastValue.indexOf(newValue) !== -1) {
                newValue = lastValue.filter((x) => x !== newValue);
            }
            else {
                newValue = [...lastValue, newValue];
            }
        }
        else {
            if (newValue === lastValue) {
                newValue = '';
            }
        }
        setValue(index, newValue);
    }
    const handleSubmit = $loader.registerHandler('appt-survey-submit', (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (formIsValid) {
            let survey = {};
            fields.forEach((item) => {
                var _a;
                if ((item.type === 'stars' && item.value > 0) ||
                    (item.type === 'binary' && typeof item.value === 'boolean') ||
                    (item.type === 'single_choice' &&
                        typeof item.value === 'string' &&
                        item.value.length > 0) ||
                    (item.type === 'multiple_choice' && Array.isArray(item.value) && item.value.length > 0) ||
                    (item.type === 'free_text' && typeof item.value === 'string' && ((_a = item.value) === null || _a === void 0 ? void 0 : _a.trim()))) {
                    survey[item.id] = item.value;
                }
            });
            let res = yield $appts.sendSurvey(fullAppt.appointment.id, { survey });
            if (res.isSuccess) {
                _core.onHide();
            }
        }
    }));
    return (_jsxs(Modal, Object.assign({ size: 'lg', centered: true, scrollable: true }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: _core.onHide }) })), _jsx(Modal.Header, { children: t('label.rate_your_appointment') }), _jsx(Modal.Body, Object.assign({ isLoading: isLoading, className: "styled_scroll" }, { children: _jsx("form", Object.assign({ id: "appt_survey_modal", onSubmit: handleSubmit }, { children: fields.map((field, index) => {
                        var _a;
                        return (field.type === 'single_choice' || field.type === 'multiple_choice') &&
                            !field.choices ? (_jsx(_Fragment, {})) : (_jsxs("div", Object.assign({ className: styles.item }, { children: [_jsx(Title, Object.assign({ size: 'h4', className: 'mb-10' }, { children: (_a = field.text) === null || _a === void 0 ? void 0 : _a.trim() })), field.type === 'stars' ? (_jsx(RatingStars, { field: {
                                        value: field.value,
                                        onChange: (value) => handleChange(index, value),
                                    } })) : field.type === 'binary' ? (_jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx(ToggleButton, { mode: ['secondary-dark', 'xs'], checkbox: { position: 'none' }, selected: typeof field.value === 'boolean' && field.value === true, onClick: () => handleChange(index, true), label: t('btn.yes') }), _jsx(ToggleButton, { mode: ['secondary-dark', 'xs'], checkbox: { position: 'none' }, selected: typeof field.value === 'boolean' && field.value === false, onClick: () => handleChange(index, false), label: t('btn.no') })] }))) : field.type === 'single_choice' || field.type === 'multiple_choice' ? (_jsx("div", Object.assign({ className: styles.buttons }, { children: field.choices.map((choice) => (_jsx(ToggleButton, { mode: ['secondary-dark', 'xs'], checkbox: { position: 'none' }, selected: Array.isArray(field.value)
                                            ? field.value.includes(choice)
                                            : Boolean(field.value), onClick: () => handleChange(index, choice), label: choice }, choice))) }))) : field.type === 'free_text' ? (_jsx(Textarea, { rows: 2, field: {
                                        value: field.value,
                                        onChange: (value) => handleChange(index, value),
                                    }, mode: 'sm', autoGrow: true })) : (_jsx(_Fragment, {}))] }), field.id));
                    }) })) })), _jsx(Modal.Footer, { children: _jsx("div", Object.assign({ className: "text-center" }, { children: _jsx(Button, Object.assign({ mode: ['primary', 'block'], form: "appt_survey_modal", disabled: !formIsValid, isLoading: $loader.isRunHandler('appt-survey-submit') }, { children: t('btn.send') })) })) })] })));
};
export default observer(ApptSurveyModal);
